import { computed, type ComputedRef, type DeepReadonly } from 'vue'

import { SPECIAL_ANSWER_FIELD_IDS } from '../../answer/constants'
import { c } from '../../intl'
import { isSpecialFieldId } from '../../question/models/Field'
import type { QuestionType } from '../../question/models/Question'

type UseCurrentQuestionOptions = (
  fields: ComputedRef<DeepReadonly<{ id: string }[]>>,
  questionType: ComputedRef<QuestionType>,
  isSpecialFieldSelected: (fieldId: string) => boolean,
) => ComputedRef<
  {
    id: 'skip' | 'na' | 'none'
    displayText: any
    selected: boolean
  }[]
>

export const useCurrentQuestionOptions: UseCurrentQuestionOptions = (
  fields,
  questionType,
  isSpecialFieldSelected,
) => {
  return computed(() =>
    fields.value.flatMap(({ id }) => {
      if (!isSpecialFieldId(id)) {
        return []
      }
      if (questionType.value === 'video' && id === SPECIAL_ANSWER_FIELD_IDS.SKIP) {
        return []
      }
      if (questionType.value === 'maxDiffSet') {
        return []
      }
      return {
        id,
        displayText: c(id),
        selected: isSpecialFieldSelected(id),
      }
    }),
  )
}
